<template>
  <div class="space__add">
    <section>
      <form @submit.prevent="validateBeforeSubmit">
        <b-field>
          <b-input
            v-model="name"
            :placeholder="$t('name.spacePlaceholder')"
            name="name"
            v-validate="'required|max:30'"
          />
        </b-field>
        <b-field label="Options" :addons="false">
          <b-switch
            v-model="isCollaboration"
            :title="$t('collab.spaceTitle')"
            name="collaboration"
            >{{ $t("collab.name") }}</b-switch
          >
          <br />
          <b-switch v-model="isPrivate" name="private">{{
            $t("private.name")
          }}</b-switch>
        </b-field>
        <b-field
          v-if="isPrivate"
          label="Password"
          :type="{ 'is-danger': errors.has('password') }"
          :message="errors.first('password')"
        >
          <b-input
            type="password"
            v-model="password"
            name="password"
            v-validate="'required'"
            password-reveal
          />
        </b-field>
        <div>
          <button
            type="submit"
            :disabled="!user"
            :title="
              !user ? $t('save.spaceAddTitleNoUser') : $t('save.spaceAddTitle')
            "
            class="button is-success is-rounded action-button"
          >
            {{ $t("save.name") }}
          </button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { generateValidUrlString } from "../../utils/helpers";

export default {
  name: "add",
  data: () => {
    return {
      name: "",
      isPrivate: false,
      isCollaboration: true,
      password: null
    };
  },
  computed: {
    ...mapGetters(["user", "tenant"])
  },
  methods: {
    ...mapActions(["createSpace"]),
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.toast.open({
            message: this.$t("form.isValid"),
            type: "is-success",
            position: "is-top-right"
          });
          this.createSpace({
            name: this.name,
            spaceId: generateValidUrlString(this.name),
            private: this.isPrivate,
            collaboration: this.isCollaboration,
            password: this.password,
            tenant: this.tenant.tenantId
          }).then(data => {
            this.$socket.emit(
              process.env.VUE_APP_SOCKET_ON,
              `${this.tenant.tenantId}`,
              data
            );
            this.$emit("added");
          });
          return;
        }
        this.$buefy.toast.open({
          message: this.$t("form.notValid"),
          type: "is-danger",
          position: "is-top-right"
        });
      });
    }
  }
};
</script>
